import { useEffect, useMemo } from 'react';
import { useTranslation } from '@frontend/i18n';
import {
  buildNoticeValue,
  PaymentMethodSetupContext,
  PaymentMethodSetupGatewayProps,
} from './payment-method-setup-base.context';

/** For a session gateway with no adapter or config here. */
export const PaymentMethodSetupUnsupportedProvider = ({
  kind,
  session,
  onCancel,
  onEvent,
  children,
}: PaymentMethodSetupGatewayProps) => {
  const { t } = useTranslation('payments');

  useEffect(() => {
    onEvent('setup_session_failed', { code: 'gateway_unsupported', gateway: session.gateway });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session]);

  const value = useMemo(
    () =>
      buildNoticeValue({
        kind,
        gateway: session.gateway,
        message: t('Saving a payment method is not available right now. Please contact the office.'),
        onCancel,
        t,
      }),
    [kind, onCancel, session.gateway, t]
  );

  return <PaymentMethodSetupContext.Provider value={value}>{children}</PaymentMethodSetupContext.Provider>;
};
